import { useEffect, useState } from "react";

/*
 * Preferências de tela de cada atendente neste navegador (sugestão do Jds
 * 04/11): esconder o "Filtro por Tags" e a linha de filtros da lista
 * (Todos, Aberta, Fechando…). O padrão é MOSTRAR; quem não usa desmarca no
 * menu ⋮. A troca vale na hora em todas as listas abertas (evento).
 */
const EVENTO = "sabezap:pref-tela";

const chave = (nome) => {
  let uid = "";
  try { uid = String((JSON.parse(localStorage.getItem("user") || "{}") || {}).id || ""); } catch (e) {}
  return `sz_pref_${uid}_${nome}`;
};

export const lerPrefTela = (nome, padrao = true) => {
  try {
    const v = localStorage.getItem(chave(nome));
    return v === null ? padrao : v === "1";
  } catch (e) {
    return padrao;
  }
};

export const gravarPrefTela = (nome, valor) => {
  try { localStorage.setItem(chave(nome), valor ? "1" : "0"); } catch (e) {}
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: { nome, valor } }));
};

export default function usePrefTela(nome, padrao = true) {
  const [valor, setValor] = useState(() => lerPrefTela(nome, padrao));
  useEffect(() => {
    const ouvir = (ev) => { if (ev && ev.detail && ev.detail.nome === nome) setValor(!!ev.detail.valor); };
    window.addEventListener(EVENTO, ouvir);
    return () => window.removeEventListener(EVENTO, ouvir);
  }, [nome]);
  return valor;
}
